import axios from 'axios';

// Charger les variables d'environnementconst 
import { BASE_URL } from "./constant";
const API_BASE = process.env.REACT_APP_API_BASE || BASE_URL+"/api";
//const BASE_URL = "https://www.yaofele.com/api"
const TOKEN = "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpZCI6MSwidXNlcm5hbWUiOiJhZG1pbiIsImlhdCI6MTc2MDA5MDM3OSwiZXhwIjoxNzYyNjgyMzc5fQ.zbC-f0PMK-LV0vWk97Y7CEkPh_Y60auhhaqz64r70g0"


const api = axios.create({
  baseURL: BASE_URL,
  headers: {
    Authorization: `Bearer ${TOKEN}`, // Ajouter le Bearer Token
    'Content-Type': 'application/json',
  },
});

export default api;